import * as React from 'react';
import * as PropTypes from 'prop-types';
import { classNames } from '@progress/kendo-react-common';
/**
 * Represents the KendoReact ToolbarSpacer component.
 * To specify an empty space, provide a ToolbarSpacer component
 * ([see example]({% slug content_toolbar %})).
 */
export var ToolbarSpacer = React.forwardRef(function (props, ref) {
    var element = React.useRef(null);
    var spacer = React.useRef(null);
    React.useImperativeHandle(spacer, function () { return ({ element: element.current }); });
    React.useImperativeHandle(ref, function () { return ({ element: element.current }); });
    var className = React.useMemo(function () { return classNames('k-spacer', props.className); }, [props.className]);
    return (React.createElement("span", { ref: element, className: className }));
});
ToolbarSpacer.displayName = 'KendoReactToolbarSpacer';
ToolbarSpacer.propTypes = {
    className: PropTypes.string
};
